<template>
    <h1>Resumen</h1>
</template>